<template>
  <div class="md:ut-flex ut-justify-between ut-items-start">
    <article class="ut-w-full ut-mb-4 md: ut-m-0">
      <div class="activity-card" :class="styleClass">
        <strong class="activity-card-text-lg">{{ value }}</strong>
        <hr class="line"/>
        <h3 class="activity-card-text">{{title}}</h3>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'ProspectActivityCard',
  components: {
   
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    styleClass: {
      type: String,
    }
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.oa-green-bg-color {
  border-radius: 3px;
  color: #fff;
  background: linear-gradient(133.45deg, #62D081 0%, #34AD56 100%);
  box-shadow: 0 0 0 1px rgba(0,0,0,0.08), 0 1px 4px 1px rgba(0,0,0,0.04);
  strong, h3{
    @apply ut-text-neutral-001;
  }
  hr {
    border-top: 1px dashed #FFF;
  }
  .activity-card-text {
    @apply ut-text-xs;
    opacity: 1;
  }
}

.activity-card {
  height: 134px;
  width: 214px;
  border-radius: 3px;
  background-color: #FFFFFF;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.08), 0 1px 4px 1px rgba(0,0,0,0.04);
  @apply ut-px-10 ut-py-8;
  
  @media (max-width: 768px) {
    width: 165px;
    @apply ut-px-6 ut-py-4;
  }
}
.activity-card-text-lg {
  color: #053636;
  font-weight: bold;
  font-size: 28px;
  letter-spacing: 0;
  @media (max-width: 768px) {
    font-size: 24px;
  }
}
.activity-card-text {
  opacity: 0.6;
  color: #053636;
  font-size: 14px;
  letter-spacing: 0;
}
.line {
  height: 1px;
  border-top: 1px dashed #8C8B89;
  width: 100%;
  @apply ut-mb-1;
}
</style>
